// Internal libraries (@stonal-tech/*)
import {
	createBaseStore,
} from '@stonal-tech/lib-front-redux-store-ts';

// Relative imports
import {
	reducers,
} from './reducers';

export const {
	persistor,
	store,
} = createBaseStore(reducers, [
	'app',
]);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
